import React from 'react';
import { topics } from '../../styles/components';
import FAQSection from './FAQSection';

// Topics component
interface ContentSectionProps {
  onTopicSelect: (promptText: string) => void;
}

interface Topic {
  id: string;
  name: string;
  count: number;
  prompt: string;
}

const ContentSection: React.FC<ContentSectionProps> = ({ onTopicSelect }) => {
  
  // Mock topics with detailed prompts - would come from API in real implementation
  const topicsList: Topic[] = [
    { 
      id: 'privacy', 
      name: 'Privacy in zkML', 
      count: 15,
      prompt: 'Explain how zero-knowledge proofs can enhance privacy in machine learning models while maintaining accuracy.'
    },
    { 
      id: 'performance', 
      name: 'Performance Optimization', 
      count: 12,
      prompt: 'What are the latest techniques for optimizing zkML circuit performance? Include recent advancements in proof generation speed.'
    },
    { 
      id: 'applications', 
      name: 'Real-world Applications', 
      count: 8,
      prompt: 'Describe real-world applications of zkML in finance, healthcare, and identity verification with specific examples.'
    },
    { 
      id: 'implementation', 
      name: 'Implementation Guides', 
      count: 10,
      prompt: 'Provide a step-by-step guide for implementing a simple neural network with zero-knowledge proof verification.'
    },
    { 
      id: 'products', 
      name: 'Our Products', 
      count: 5,
      prompt: 'List the key features and benefits of all zkML research products currently available in the market.'
    }
  ];

  const handleTopicClick = (topic: Topic) => {
    // Fill the search box with the detailed prompt
    onTopicSelect(topic.prompt);
  };

  return (
    <div className="space-y-8">
      {/* Topics Section */}
      <div>
        <h2 className={topics.sectionHeader}>Popular Topics</h2>
        <div className={topics.container}>
          {topicsList.map((topic) => (
            <button
              key={topic.id}
              onClick={() => handleTopicClick(topic)}
              className={topics.chip}
            >
              {topic.name}
              <span className={topics.count}>({topic.count})</span>
            </button>
          ))}
        </div>
      </div>
      
      {/* FAQ Section */}
      <FAQSection onQuestionSelect={onTopicSelect} />
    </div>
  );
};

export default ContentSection;
